import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BlockedVisitorExportRequest } from "./BlockedVisitorExportRequest";
import { VisitorImportRequest } from "./VisitorImportRequest";
import { BlockedExceptionUpdateRequest } from "./BlockedExceptionUpdateRequest";

@Injectable()
export class DataService_MultiStationBlockedVisitors {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BlockedVisitorSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/BlockedVisitorSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GetPhotoByPerson(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/GetPhotoByPerson?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	ExportFormatOptionSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/ExportFormatOptionSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	BlockedVisitorExport(parms: BlockedVisitorExportRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/BlockedVisitorExport";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorModifyListInfoSelect() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorModifyListInfoSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	BlockedVisitorImportColumnInfoSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/BlockedVisitorImportColumnInfoSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorImport(parms: VisitorImportRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorImport";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	BlockedExceptionSelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/BlockedExceptionSelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	BlockedExceptionUpdate(parms: BlockedExceptionUpdateRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/BlockedExceptionUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
